document.addEventListener("DOMContentLoaded", function() {
    const scrollContainer = document.querySelector(".blog-categories--scroll");
    const activeItem = scrollContainer.querySelector(".blog-categories--item.active");
    
    if (activeItem) {
        // Calculate the position to scroll to center the active item
        const containerWidth = scrollContainer.offsetWidth;
        const itemOffsetLeft = activeItem.offsetLeft;
        const itemWidth = activeItem.offsetWidth;
        
        // Scroll the container so the active item is centered
        scrollContainer.scrollLeft = itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2);
    }
});